module.exports = __webpack_public_path__ + "d6134d0c8dff60a14da89c1fd231b3b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_25.jpg
// module id = 1772
// module chunks = 5